import Loader from '../../components/Loader.vue'
import App from "@/App.vue";
// Orders
import OrdersList from '../../components/Orders/Index.vue'
import OrderPrint from '../../components/Orders/Print.vue'
import OrderDetails from '../../components/Orders/Details.vue'
import NewOrder from '../../components/Orders/NewOrder.vue'
import ProcessNewOrder from '../../components/Orders/ProcessNewOrder.vue'
//Products
import ProductsList from '../../components/Product/Index.vue'
import AddProduct from '../../components/Product/AddProduct.vue'
import EditProduct from '../../components/Product/EditProduct.vue'
//Categories
import AddCategory from '../../components/Category/AddCategory.vue'
import ShowCategory from '../../components/Category/EditCategory.vue'
//Shop
import Shop from '../../components/Shop/Index.vue'
//Sub Categories
import SubCategories from '../../components/SubCategory/Index.vue'
// Users
import Users from '../../components/Users/Index.vue';
import UserDetails from '../../components/Users/Details.vue';
import NewUser from '../../components/Users/AddUser.vue';
// Coupons
import Coupons from '../../components/Coupon/Index.vue';
import CouponDetails from '../../components/Coupon/Details.vue';
// general coupons
import GeneralCoupons from '../../components/GeneralCoupons/Index.vue';
// Jobs
import Jobs from '../../components/Jobs/Index.vue';
import JobDetails from '../../components/Jobs/Details.vue';
import NewJob from '../../components/Jobs/NewJob.vue';
import UsersJob from '../../components/Jobs/Users.vue';
import PromotionDetailsJob from '../../components/Jobs/PromotionDetails.vue';
// Sliders
import Sliders from '../../components/Sliders/Index.vue';
import NewSlider from '../../components/Sliders/AddSlider.vue';
import DetailsSlider from '../../components/Sliders/Details.vue';
// Country
import Country from '../../components/Country/Index.vue';
// Finance
import Finance from '../../components/Finance/Index.vue';
// Dictionary
import Dictionary from '../../components/Dictionary/Index.vue';
// Advertisment
import Advertisment from '../../components/Advertisment/Index.vue';
// Setting
import Setting from '../../components/Setting/Index.vue';
import SettingHome from '../../components/Setting/Home/Index.vue';
import SettingPrice from '../../components/Setting/Price/Index.vue';
import SettingText from '../../components/Setting/Text/Index.vue';
import SettingOrderCancel from '../../components/Setting/OrderCancelReason/Index.vue';
// Gift
import Gift from '../../components/Gift/Index.vue';
// Comments
import Comments from '../../components/Comments/Index.vue';
// Stock
import Stock from '../../components/Stock/Index.vue';
import StockAddGroup from '../../components/Stock/AddGroup.vue';
import DetailsGroup from '../../components/Stock/DetailsGroup.vue';
import DetailsStock from '../../components/Stock/Details.vue';
// Maps
import Maps from '../../components/Maps/Index.vue';
// Customers
import Customers from '../../components/Customers/Index.vue';
import CustomerDetails from '../../components/Customers/Details.vue';
//Category Countries
import CategoryCountries from '../../components/CategoryCountries/Index.vue'
//Gallery
import Gallery from '../../components/Gallery/Index.vue'
//Excel exporter
import ExcelExporter from '../../components/ExcelExporter/Index.vue'



//middleware
import AdminMiddleware from './Middleware/admin'
import LoginMiddleware from './Middleware/login'


const allUrl = [
    {
        path: '/', component: Loader,
    },
    {
        path: '/admin', component: Loader, redirect: '/admin/orders', meta: {
            middleware: [
                AdminMiddleware,
            ]
        },
        children: [
            {
                path: 'customers',
                name: 'Customers',
                component: Customers,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Großhandel"
                }
            },
            {
                path: 'customer/details/:customerid',
                name: 'CustomerDetails',
                component: CustomerDetails,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Großhandel Details"
                }
            },
            {
                path: 'orders',
                name: 'OrdersList',
                component: OrdersList,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Aufträge"
                }
            },
            {
                path: 'gallery',
                name: 'Gallery',
                component: Gallery,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Gallery"
                }
            },
            {
                path: 'new/order',
                name: 'NewOrder',
                component: NewOrder,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Neu Bestellung"
                }
            },
            {
                path: 'process/new/order',
                name: 'ProcessNewOrder',
                component: ProcessNewOrder,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Neu Bestellung"
                }
            },
            {
                path: 'order/print/:orderid',
                name: 'OrdersPrint',
                component: OrderPrint,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Bestellung drucken"
                }
            },
            {
                path: 'order/details/:orderid',
                name: 'OrderDetails',
                component: OrderDetails,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Bestellinformationen"
                }
            },
            {
                path: 'products/:categoryid',
                name: 'ProductsList',
                component: ProductsList,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Produkte"
                }
            },
            {
                path: 'new/product/:categoryid',
                name: 'AddProduct',
                component: AddProduct,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Neue Produkte"
                }
            },
            {
                path: 'edit/product/:productid',
                name: 'EditProduct',
                component: EditProduct,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Edit Produkte"
                }
            },
            {
                path: 'new/category',
                name: 'AddCategory',
                component: AddCategory,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Neue Kategorie"
                }
            },
            {
                path: 'category/countries/:categoryid',
                name: 'CategoryCountries',
                component: CategoryCountries,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Category Countries"
                }
            },
            {
                path: 'show/category/:categoryid',
                name: 'ShowCategory',
                component: ShowCategory,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Edit Kategorie"
                }
            },
            {
                path: 'users',
                name: 'Users',
                component: Users,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Benutzer"
                }
            },
            {
                path: 'user/details/:userid',
                name: 'UserDetails',
                component: UserDetails,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Benutzer Einzelheiten"
                }
            },
            {
                path: 'user/new',
                name: 'NewUser',
                component: NewUser,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Neue Benutzer"
                }
            },
            {
                path: 'coupons',
                name: 'Coupon',
                component: Coupons,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Gutscheine"
                }
            },
            {
                path: 'coupon/details/:userid',
                name: 'CouponDetails',
                component: CouponDetails,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Gutscheine Einzelheiten"
                }
            },
            {
                path: 'shop',
                name: 'Shop',
                component: Shop,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Shop"
                }
            },
            {
                path: 'subcategory/:categoryid',
                name: 'SubCategory',
                component: SubCategories,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Sub Categories"
                }
            },
            {
                path: 'general/coupons',
                name: 'GeneralCoupons',
                component: GeneralCoupons,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "General Coupons"
                }
            },
            {
                path: 'jobs',
                name: 'Jobs',
                component: Jobs,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Jobs"
                }
            },
            {
                path: 'jobs/users',
                name: 'JobUsers',
                component: UsersJob,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "User Jobs"
                }
            },
            {
                path: 'new/job',
                name: 'NewJob',
                component: NewJob,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "New Job"
                }
            },
            {
                path: 'job/details/:jobid',
                name: 'DetailsJob',
                component: JobDetails,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Details Job"
                }
            },
            {
                path: 'job/promotion/user/details/:id',
                name: 'PromotionUserDetailsJob',
                component: PromotionDetailsJob,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Details Promotion Job"
                }
            },
            {
                path: 'sliders',
                name: 'Sliders',
                component: Sliders,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Sliders"
                }
            },
            {
                path: 'new/slider',
                name: 'NewSlider',
                component: NewSlider,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "New Slider"
                }
            },
            {
                path: 'slider/details/:sliderid',
                name: 'SliderDetails',
                component: DetailsSlider,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Details Slider"
                }
            },
            {
                path: 'country',
                name: 'Country',
                component: Country,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Countries"
                }
            },
            {
                path: 'finance',
                name: 'Finance',
                component: Finance,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Finance"
                }
            },
            {
                path: 'dictionary',
                name: 'Dictionary',
                component: Dictionary,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Dictionary"
                }
            },
            {
                path: 'advertisment',
                name: 'Advertisment',
                component: Advertisment,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Advertisment"
                }
            },
            {
                path: 'setting',
                name: 'Setting',
                component: Setting,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Setting"
                }
            },
            {
                path: 'setting/price',
                name: 'SettingPrice',
                component: SettingPrice,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Setting Price"
                }
            },
            {
                path: 'setting/home',
                name: 'SettingHome',
                component: SettingHome,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Setting Home"
                }
            },
            {
                path: 'setting/text',
                name: 'SettingText',
                component: SettingText,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Setting Text"
                }
            },
            {
                path: 'setting/orderText',
                name: 'SettingOrderCancel',
                component: SettingOrderCancel,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Setting Text Order"
                }
            },
            {
                path: 'gift',
                name: 'Gift',
                component: Gift,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Geschenk"
                }
            },
            {
                path: 'comments',
                name: 'Comments',
                component: Comments,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Comments"
                }
            },
            {
                path: 'stock',
                name: 'Stock',
                component: Stock,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Lager"
                }
            },
            {
                path: 'stock/add/group/:groupid?',
                name: 'StockAddGroup',
                component: StockAddGroup,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Lager New Group"
                }
            },
            {
                path: 'stock/details/group/:groupid',
                name: 'DetailsGroup',
                component: DetailsGroup,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Details Group"
                }
            },
            {
                path: 'stock/details/:productid',
                name: 'DetailsStock',
                component: DetailsStock,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Details Group"
                }
            },
            {
                path: 'maps',
                name: 'Maps',
                component: Maps,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Maps"
                }
            },
            {
                path: 'excel/exporter',
                name: 'ExcelExporter',
                component: ExcelExporter,
                meta: {
                    middleware: [
                        AdminMiddleware,
                    ],
                    title: "Excel Exporter"
                }
            },
        ]
    },
    {
        path: '/auth/login', name: 'AuthLogin', component: Loader,
    }
];
export default allUrl;